import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Job Board',
        projectDesc: 'This project is a job board application that allows users to search and filter job listings based on various criteria.',
        tags: ['JavaScript', 'CSS', 'HTML', 'API'],
        code: 'https://github.com/dmorton714/CodeYouJobBoard',
        demo: 'https://dmorton714.github.io/CodeYouJobBoard/',
        image: one
    },
    {
        id: 2,
        projectName: 'Baltimore Salary Tracker',
        projectDesc: 'An interactive dashboard that tracks the salaries of Baltimore city employees.',
        tags: ['Python', 'Plotly', 'Pandas', 'API', 'Streamlit'],
        code: 'https://github.com/dmorton714/baltimore',
        demo: 'https://baltimore.streamlit.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Pokemon Analysis',
        projectDesc: 'This project demonstrates how a workflow can be migrated from a Jupyter Notebook into a more production-ready environment.',
        tags: ['Python', 'Plotly', 'Pandas', 'API'],
        code: 'https://github.com/dmorton714/pokemon_analysis_project',
        demo: '',
        image: three
    },
    {
        id: 4,
        projectName: 'Android Patient Tracker',
        projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
        tags: ['Flutter', 'Firebase'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: four
    },
    {
        id: 5,
        projectName: 'E-Commerce App',
        projectDesc: 'A Simple E-commerce application',
        tags: ['React Native', 'Firebase'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: five
    },
    {
        id: 6,
        projectName: 'Uber Lite',
        projectDesc: 'Uber clone',
        tags: ['Flutter'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: six
    },
    {
        id: 7,
        projectName: 'Stock Market App',
        projectDesc: 'A simple stock market API app',
        tags: ['React', 'Redux', 'Bootstrap'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: seven
    },
    {
        id: 8,
        projectName: 'Car Pooling System',
        projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
        tags: ['Flutter', 'React'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/